import React from "react";

import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Stack from "react-bootstrap/Stack";

import { DateInputWrapper } from "../../../../components/DateInputWrapper";

export default function PaymentPlan({ idx, plan, setPaymentDate }) {
  return (
    <Stack
      direction="horizontal"
      gap={4}
      as="li"
      className="align-items-center"
    >
      <span className="form-label">Payment {plan?.id}</span>
      <div className="flex">
        <Form.Group>
          <Form.Label className="form-label--lowercase form-label-sm fw-medium mb-2">
            Amount
          </Form.Label>
          <InputGroup>
            <InputGroup.Text id="amount">$</InputGroup.Text>
            <Form.Control
              placeholder="Amount"
              id={plan?.id}
              name="amount"
              aria-describedby="amount"
              pattern="^[0-9.]*$"
              value={plan?.amount || ""}
              required
              disabled
            />
          </InputGroup>
        </Form.Group>
        <Form.Group>
          <Form.Label className="form-label-sm form-label--lowercase mb-2">
            Due Date
          </Form.Label>
          <DateInputWrapper
            id="payment-start"
            setDate={(date) => setPaymentDate(date)}
            selectedDate={plan?.dueDate}
            startDate={plan?.dueDate}
            minDate={new Date()}
            size="sm"
            styles="form-control-height"
            isReadOnly={idx > 0 ? true : false}
          />
        </Form.Group>
      </div>
    </Stack>
  );
}
